

// Drop the home tab for an item that stopped existing. Same identity-preserving
// contract as renameHomeTab.

// Initial collapse of a SplitPage detail panel from the persisted ?dcol param.
// An explicit value wins ("collapsed" / "open"); absent falls back to the
// page's default.
export function resolveDetailCollapsed(dcolParam, defaultCollapsed) {
    if (dcolParam === "collapsed") return true;
    if (dcolParam === "open") return false;
    return !!defaultCollapsed;
}

// The ?dcol value to persist: only the NON-default state, so a page sitting at
// its default keeps a clean URL. Returns null to clear the param.
export function detailCollapseParam(collapsed, defaultCollapsed) {
    if (!!collapsed === !!defaultCollapsed) return null;
    return collapsed ? "collapsed" : "open";
}
